import {RouterPaths} from "../routerPaths";
import {importPages} from "../lazyRoute";

const hrRoutes = [


    {
        path: RouterPaths.EMPLOYEES,
        element:importPages.Employees
    },
    {
        path: RouterPaths.EMPLOYEESOVERVIEW,
        element:importPages.EmployeesOverview
    },
    {
        path: RouterPaths.EMPLOYEESSETTINGS,
        element:importPages.EmployeesSettings
    },


    {
        path: RouterPaths.ACADEMICPOSITIONS,
        element:importPages.AcademicPositions
    },

    {
        path: RouterPaths.POSITIONSWORKINGHOURS,
        element:importPages.PositionsWorkingHours
    },
    {
        path: RouterPaths.ROLESASSOCIATIONS,
        element:importPages.RolesAssociations
    },
]
export default hrRoutes